let productsToggler = document.querySelectorAll('.products-header')

if(productsToggler.length) {
    for(let item of productsToggler) {
        item.addEventListener('click', () => {
            let parent = item.parentElement

            parent.classList.toggle('hide')
        })
    }
}